<script setup lang="ts">
import {saving} from "@/Composables/api.ts";
import QuestionComponents from "@/Pages/User/Questions/Question/Types";
import {Icon} from "@iconify/vue";
import {Button} from "@/Components/Library";
import Question from "@/Models/Question.ts";

const props = defineProps<{
    question: Question;
    saving: boolean;
    isSaved: boolean;
}>();
const model = defineModel();
console.log(props.question);
</script>
<template>
    <div>
        <div class="mb-4 flex">
            <h3 class="font-bold text-stone-500 lg:px-0 dark:text-stone-400">Your {{ question.type.name }} Response</h3>
            <div class="ml-auto flex items-center gap-1">
                <p class="text-xs">
                    <span v-if="!!saving && !saving.includes('vote')">Saving</span>
                    <span v-else-if="isSaved">Saved</span>
                    <span v-else>Not saved</span>
                </p>
                <Icon
                    :icon="
                        !!saving && !saving.includes('vote')
                            ? 'line-md:loading-twotone-loop'
                            : 'material-symbols:save-rounded'
                    "
                    width="24"
                    :class="[isSaved && !saving && !saving.includes('vote') ? 'text-askr-green' : 'text-amber-500']"
                />
            </div>
        </div>
        <div class="mb-8" ref="responseBlock">
            <div v-auto-animate>
                <!--            <div v-if="!showResponseForm && !showResponses">-->
                <!--                <div class="flex items-start">-->
                <!--                    &lt;!&ndash;                                <FormattedResponseData :question="question" :response="ownResponse" />&ndash;&gt;-->
                <!--                    <Button-->
                <!--                        v-if="question.param('allow_editing')"-->
                <!--                        @click="state.show.responseForm = true"-->
                <!--                        icon="material-symbols:edit-outline"-->
                <!--                        class="ml-auto"-->
                <!--                    />-->
                <!--                </div>-->
                <!--            </div>-->
                <form @submit.prevent="$emit('save')">
                    <div v-if="question.id">
                        <Component
                            ref="responseComponent"
                            :is="QuestionComponents[question.type.slug]"
                            :question="question"
                            v-model="model"
                        />
                    </div>
                    <div class="flex flex-col items-center">
                        <Button
                            type="submit"
                            icon="material-symbols:save-outline"
                            :loading="!!saving && !saving.includes('vote')"
                            class="mt-4 w-full bg-askr-green px-4 py-2 font-bold text-white"
                        >
                            Save my response
                        </Button>
                        <Button class="py-0.5 text-sm font-normal !ring-0" @click="$emit('cancel')">Cancel</Button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<style scoped></style>
